/* eslint-disable no-unused-expressions */
export const onClientEntry = () => {
  // IntersectionObserver polyfill for Safari, IE
  if (!('IntersectionObserver' in window)) {
    import('intersection-observer');
  }

  // crypto polyfill for ie11
  if (!window.crypto) {
    window.crypto = window.msCrypto;
  }

  import('isomorphic-fetch');
  import('web-vitals/dist/polyfill.js');
};

export function onServiceWorkerUpdateReady() {
  // should force a refresh of site to remove any cached files.
  window.location.reload(true);
}

require('@carvana/showroom-css-theme/Theme.css');
require('@carvana/showroom-forms/index.css');
